import { type Nil } from "@mcwd/typescript-type-guards";
import { GatingLevel } from "../../types/definitions/gating/gating-level.js";
import type { IFormSettings } from "../../form-settings/form-settings-factory.js";


export function getGatingLevelFromSelf(settings: IFormSettings): GatingLevel.MarketoForm | Nil {
  const { gateLevelSource, defaultGateLevel } = settings;
  if (gateLevelSource.includes("Self")) {
    return defaultGateLevel as "FullGate" | "PartialGate";
  }
  return null;
}